'use client';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { PulseIconButton } from 'src/components/PulseUI';
import { selectPendingProvider, clearPendingProvider } from 'src/redux';

export interface PendingProviderBannerProps {
  className?: string;
}

const PendingProviderBanner: React.FC<PendingProviderBannerProps> = ({
  className = '',
}) => {
  const dispatch = useDispatch();
  const pendingProvider = useSelector(selectPendingProvider);

  if (!pendingProvider) return null;

  const handleDismiss = () => {
    dispatch(clearPendingProvider());
  };

  return (
    <div
      className={`flex items-center gap-3 p-3 bg-amber-50 border-b border-amber-200 ${className}`}
      data-testid="pending-provider-banner"
      role="alert"
      aria-label={`Pending provider: ${pendingProvider.name}`}
    >
      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-amber-100 flex-shrink-0">
        <Icon icon={faUserPlus} className="w-4 h-4 text-amber-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-amber-900 truncate">
          {pendingProvider.name}
        </p>
        <p className="text-xs text-amber-700">
          Select a route or create new to add
        </p>
      </div>
      <PulseIconButton
        variant="plain"
        color="neutral"
        size="sm"
        icon={faXmark}
        onClick={handleDismiss}
        tooltip="Dismiss"
        aria-label="Dismiss pending provider"
        data-testid="pending-provider-dismiss"
      />
    </div>
  );
};

export default PendingProviderBanner;
